import type { HTMLAttributes } from 'react';

type CardSize = 'md' | 'lg';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** `md` (default): 4-unit padding for dense surfaces. `lg`: 7-8 unit padding for hero / auth surfaces. */
  size?: CardSize;
}

const SIZE: Record<CardSize, string> = {
  md: 'p-4',
  lg: 'p-7 sm:p-8',
};

export function Card({ size = 'md', className, ...rest }: CardProps): JSX.Element {
  const cls = [
    // Soft 2-stop shadow gives a "lifted" feel without the heavy bottom-shadow
    // look — closer to Stripe / Linear surface chrome than `shadow-sm`.
    'glass-panel rounded-xl border shadow-[0_1px_2px_rgb(0_0_0/0.04),_0_8px_24px_-12px_rgb(0_0_0/0.08)]',
    SIZE[size],
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  return <div className={cls} {...rest} />;
}
